
const get_cid = () => {
  const cid = localStorage.getItem("cid");
  return cid;
};

export default get_cid;
